import React from "react";
import error from "../assets/images/error-page-icon.png";
import { useNavigate } from "react-router-dom";
import style from "./Error.module.scss";

const Error = () => {
  const navigate = useNavigate();
  return (
    <div className={style.main}>
      <div className="text-center">
        <img className="mt-3" src={error} alt="icons" />
        <h1 className="mt-2">404</h1>
        <h3>Sorry, Page Not Found!</h3>
        <button className="mt-4" onClick={(e) => navigate("/app/lms")}>
          BACK TO HOME
        </button>
      </div>
    </div>
  );
};

export default Error;
